module.exports = __webpack_public_path__ + "img/icons_23.c5d069ab.png";